// =============================================================================
// Role, które print-core wpuszcza na trasy administracyjne organu druku.
//
// LUSTRO `ORG_ADMIN_ROLES` z `services/print-core/src/auth/types.ts`. Cztery
// trasy układu (`/api/print/templates/:slug/uklad` i pozostałe trzy) stoją na
// `userGate` + `requireOrgAdmin`, a ten dopuszcza CZTERY role — nie dwie.
//
// Rozjazd tej listy z backendem kosztuje w obie strony:
//   • węższa niż backend — chowa przycisk przed kimś uprawnionym, a odkąd
//     brama mówi, czym jest, jeszcze mu wmawia, że nie ma roli. Dokładnie to
//     spotkało konto `partner`;
//   • szersza niż backend — pokazuje kontrolkę, którą trasa i tak zetnie 403.
//
// To jest UKRYCIE KONTROLKI, nie granica bezpieczeństwa: ostatnie słowo ma
// `requireOrgAdmin` po stronie print-core. Set-equality z backendem pilnuje
// `tests/unit/apps/printingRolaAdmina.test.ts` — bez niej lista rozjeżdża się
// po cichu, bo nic w typach nie łączy jej ze źródłem prawdy.
// =============================================================================

import type { UserRole } from '../../../types/auth';

export const ROLE_ADMINA_DRUKU = [
  'super_admin',
  'partner',
  'owner',
  'admin',
] as const satisfies readonly UserRole[];
